import CurrencyModel from '@/model/currency-model';

export default class CustomerKycModel {
  constructor(obj) {
    obj = obj || {};

    this.estimatedAnnualVolumeUsd = obj.estimatedAnnualVolumeUsd != null ? parseFloat(obj.estimatedAnnualVolumeUsd) : null;
    this.currency = obj.currency ? new CurrencyModel(obj.currency) : null;
    this.destinationCountry = obj.destinationCountry ?? null;
  }
}
